module.exports = __webpack_public_path__ + "static/img/App item-4.a9816f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls39/App item-4.png
// module id = fFg+
// module chunks = 12